import router from "@/router";
import store from "@/store";
import { reactive, onBeforeMount, onBeforeUpdate } from "@vue/composition-api";
import { dynamicTable } from "@/configs/dynamic-config/dynamic-table";
import { dynamicBi } from "@/configs/dynamic-config/dynamic-bi";

export default function useDataManagementList() {
  const dynamicBIConfig = reactive({
    isShow: false,
  });

  const dynamicTableConfig = reactive({
    isShow: true,
    displayKey: "",
    queryId: "",
    displayId: "",
    queryDataKey: null,
    isCreate: false,
  });

  const getDisplayKey = () => {
    let data = dynamicTable.config[router.currentRoute.params.ref] || {}
    dynamicTableConfig.displayKey = data.displayKey;
    dynamicTableConfig.queryId = data.queryId;
    dynamicTableConfig.queryDataKey = data.queryDataKey;
    dynamicTableConfig.displayId = data.displayId;
    dynamicTableConfig.isCreate = data.isCreate;
  };

  const displayDynamicBi = () => {
    let data = dynamicBi.show.indexOf(new URLSearchParams(window.location.search).get('brandRef')) != -1 ? true : false
    dynamicBIConfig.isShow = data;
  };

  onBeforeMount(() => {
    displayDynamicBi();
    getDisplayKey();
  });

  onBeforeUpdate(() => {
    getDisplayKey();
  });

  return {
    dynamicBIConfig,
    dynamicTableConfig,
  };
}
